import { render, staticRenderFns } from "./backLogin.vue?vue&type=template&id=a0aab6b8&scoped=true&"
import script from "./backLogin.vue?vue&type=script&lang=js&"
export * from "./backLogin.vue?vue&type=script&lang=js&"
import style0 from "./backLogin.vue?vue&type=style&index=0&lang=less&"
import style1 from "./backLogin.vue?vue&type=style&index=1&id=a0aab6b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0aab6b8",
  null
  
)

export default component.exports